import { Routes, Route, Navigate } from 'react-router-dom'
import DashboardLayout from '../../components/Dashboard/DashboardLayout'
import DashboardHome from './DashboardHome'
import EventsManagement from './EventsManagement'
import BrunchManagement from './BrunchManagement'
import UsersManagement from './UsersManagement'
import BewerbungManagement from './BewerbungManagement'
import Settings from './Settings'

export default function Dashboard() {
  const token = localStorage.getItem('dashboard_token')

  // Ohne gültigen Token: Sofort zur Login-Seite umleiten
  if (!token) {
    return <Navigate to="/dashboard/login" replace />
  }

  return (
    <DashboardLayout>
      <Routes>
        <Route index element={<DashboardHome />} />
        <Route path="events" element={<EventsManagement />} />
        <Route path="brunches" element={<BrunchManagement />} />
        <Route path="users" element={<UsersManagement />} />
        <Route path="bewerbung" element={<BewerbungManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="media" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  )
}
















